module.exports = __webpack_public_path__ + "images/133_4096.jpg";